import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "title-default" }
const _hoisted_2 = { class: "title-default__h1" }
const _hoisted_3 = {
  key: 0,
  class: "title-default__p"
}

interface LocalProps {
    title:     string,
    subtitle?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TitleDefault',
  props: {
    title: { default: 'Заголовок' },
    subtitle: { default: '' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.title), 1),
    (_ctx.subtitle)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.subtitle), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})